/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { CreateSberPayPaymentMutationRequest, CreateSberPayPaymentMutationResponse, CreateSberPayPayment400, CreateSberPayPayment401, CreateSberPayPayment404, CreateSberPayPayment500 } from "../entities/CreateSberPayPayment";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createSberPayPayment } from "../api/createSberPayPayment";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createSberPayPaymentMutationKey = () => [{ url: '/api/v1/payments/sberpay' }] as const

export type CreateSberPayPaymentMutationKey = ReturnType<typeof createSberPayPaymentMutationKey>

export function createSberPayPaymentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateSberPayPaymentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createSberPayPaymentMutationKey()
        return mutationOptions<CreateSberPayPaymentMutationResponse, ResponseErrorConfig<CreateSberPayPayment400 | CreateSberPayPayment401 | CreateSberPayPayment404 | CreateSberPayPayment500>, {data: CreateSberPayPaymentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return createSberPayPayment(data, config)
          },
        })

}

/**
 * @description Создает новый платеж через платежную систему SberPay.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * - Минимальная сумма платежа: 240 рублей (24000 копеек)
 * - Максимальная сумма платежа: 9000 рублей (900000 копеек)
 * - ОС устройства пользователя: android, ios
 * - URL для возврата пользователя после оплаты c виджета SberPay
 * **Процесс:**
 * 1. Валидация входных данных
 * 1.1. Проверка, что сумма платежа находится в допустимом диапазоне
 * 1.2. Проверка, что ОС устройства пользователя является допустимой
 * 1.3. Проверка, что URL для возврата пользователя после оплаты c виджета SberPay является допустимым (не пустой строкой)
 * 2. Создание записи в БД
 * 3. Создание платежа в СберПей
 * 4. Возврат ответ с идентификатором заказа в системе СберПей и URL для возврата пользователя после оплаты c виджета SberPay
 * @summary Инициализация платежа через SberPay
 * {@link /api/v1/payments/sberpay}
 */
export function useCreateSberPayPayment<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateSberPayPaymentMutationResponse, ResponseErrorConfig<CreateSberPayPayment400 | CreateSberPayPayment401 | CreateSberPayPayment404 | CreateSberPayPayment500>, {data: CreateSberPayPaymentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateSberPayPaymentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createSberPayPaymentMutationKey()

          const baseOptions = createSberPayPaymentMutationOptions(config) as UseMutationOptions<CreateSberPayPaymentMutationResponse, ResponseErrorConfig<CreateSberPayPayment400 | CreateSberPayPayment401 | CreateSberPayPayment404 | CreateSberPayPayment500>, {data: CreateSberPayPaymentMutationRequest}, TContext>
          

          return useMutation<CreateSberPayPaymentMutationResponse, ResponseErrorConfig<CreateSberPayPayment400 | CreateSberPayPayment401 | CreateSberPayPayment404 | CreateSberPayPayment500>, {data: CreateSberPayPaymentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateSberPayPaymentMutationResponse, ResponseErrorConfig<CreateSberPayPayment400 | CreateSberPayPayment401 | CreateSberPayPayment404 | CreateSberPayPayment500>, {data: CreateSberPayPaymentMutationRequest}, TContext>
      
}